export default __webpack_public_path__ + "static/media/phucngam.40285742.png";